<script setup lang="ts">
import {
  mdiViewList,
  mdiInformation,
  mdiRestart,
  mdiHumanGreetingVariant,
} from '@quasar/extras/mdi-v7';

type Props = {
  showViewResults?: boolean;
  showResetStep?: boolean;
  showGetHelp?: boolean;
  showInfo?: boolean;
};

withDefaults(defineProps<Props>(), {
  showViewResults: false,
  showResetStep: false,
  showGetHelp: false,
  showInfo: false,
});

const emits = defineEmits<{
  'view-results': [];
  'reset-step': [];
  'get-help': [];
  'show-info': [];
}>();
</script>

<template>
  <div
    elevated
    class="row step-footer"
  >
    <q-toolbar>
      <q-btn
        v-if="showViewResults"
        flat
        round
        :icon="mdiViewList"
        :title="$t('VIEW_RESULTS')"
        color="accent"
        @click="emits('view-results')"
      />
      <q-btn
        v-if="showResetStep"
        flat
        round
        :icon="mdiRestart"
        :title="$t('RESET_STEP')"
        color="accent"
        @click="emits('reset-step')"
      />
      <q-btn
        v-if="showGetHelp"
        flat
        round
        :icon="mdiHumanGreetingVariant"
        :title="$t('GET_HELP')"
        color="accent"
        @click="emits('get-help')"
      />
      <slot name="button-start" />
      <q-space />
      <slot name="button-end" />
      <q-btn
        v-if="showInfo"
        flat
        round
        :icon="mdiInformation"
        :title="$t('SHOW_INFO')"
        color="info"
        @click="emits('show-info')"
      />
    </q-toolbar>
  </div>
</template>

<style scoped>
.step-footer {
  background-color: var(--q-color-secondary);
  color: var(--q-color-dark);
  justify-content: space-around;
}
</style>
